export default __webpack_public_path__ + "static/media/a011-startup-05.565f06fd.svg";